export default {
  title: 'Elige el paquete que más te convenga'
};



// WEBPACK FOOTER //
// ./src/i18n/sv/packages.js